import KpiRow from "@/components/dashboard/KpiRow";
import LiveActivity from "@/components/dashboard/LiveActivity";
import ConversionFunnel from "@/components/dashboard/ConversionFunnel";
import WhyThisExists from "@/components/dashboard/WhyThisExists";
import { PlayCircle } from "lucide-react";
import { useDemo } from "@/demo/DemoContext";

export default function Dashboard() {
  const { startTour } = useDemo();
  return (
    <div data-testid="dashboard-page" className="max-w-[1400px] mx-auto space-y-8">
      {/* Purpose Statement */}
      <section data-testid="purpose-banner" className="enter-up">
        <div className="flex items-start gap-4">
          <div
            style={{
              width: 4,
              alignSelf: "stretch",
              background: "linear-gradient(180deg, #00C2A8, #0EA5E9)",
              borderRadius: 4,
              minHeight: 68,
            }}
          />
          <div className="flex-1">
            <div
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 11,
                letterSpacing: "0.14em",
                color: "var(--accent-teal)",
                textTransform: "uppercase",
                marginBottom: 6,
              }}
            >
              Command Center · Feb 2026
            </div>
            <h1
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 800,
                fontSize: 26,
                letterSpacing: "-0.02em",
                color: "var(--text-primary)",
                lineHeight: 1.25,
                maxWidth: 900,
              }}
            >
              Your MQLs are converting at{" "}
              <span style={{ color: "#EF4444" }}>2%</span>. Industry top-performers hit{" "}
              <span style={{ color: "#00C2A8" }}>21%</span>. This system closes that gap with always-on AI across voice, email, and SMS — without adding headcount.
            </h1>
          </div>
          <button
            data-testid="start-tour-btn"
            onClick={startTour}
            className="inline-flex items-center gap-2 rounded-lg flex-shrink-0"
            style={{
              padding: "9px 14px",
              background: "transparent",
              border: "1px solid rgba(0, 194, 168, 0.40)",
              color: "#00C2A8",
              fontFamily: "Inter, sans-serif",
              fontSize: 12.5,
              fontWeight: 600,
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "all 150ms ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(0, 194, 168, 0.10)";
              e.currentTarget.style.borderColor = "rgba(0, 194, 168, 0.70)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.borderColor = "rgba(0, 194, 168, 0.40)";
            }}
          >
            <PlayCircle size={14} />
            Start Demo Tour
          </button>
        </div>
      </section>

      {/* KPI Row */}
      <KpiRow />

      {/* 2-col: Activity + Funnel */}
      <section className="grid grid-cols-12 gap-6">
        <div className="col-span-12 lg:col-span-7">
          <LiveActivity />
        </div>
        <div className="col-span-12 lg:col-span-5">
          <ConversionFunnel />
        </div>
      </section>

      {/* Why This Exists */}
      <WhyThisExists />
    </div>
  );
}
